import { IDetailsColumnStyles } from '@fluentui/react';
import { ColumnData } from 'common/components/SearchBar';

export const getColumn = (columnKey: string, existingColumns: ColumnData[]) => {
  const filterColumn = existingColumns.filter(
    (column) => column.key === columnKey
  );
  return filterColumn[0];
};

export const getSortedColumns = (
  clickedColumn: ColumnData,
  existingColumns: ColumnData[]
) => {
  const desc =
    clickedColumn?.isSortedDescending === undefined
      ? false
      : !clickedColumn?.isSortedDescending;
  const newColumns = existingColumns.map((col) => ({
    ...col,
    isSorted: clickedColumn?.key === col.key,
    isSortedDescending: clickedColumn?.key === col.key ? desc : undefined,
  }));

  return { newColumns, desc };
};

const hasWindow = typeof window !== 'undefined';

export const getWindowDimensions = () => {
  const width = hasWindow ? window.innerWidth : null;
  const height = hasWindow ? window.innerHeight : null;
  return {
    width,
    height,
  };
};
export const getSubtractedValue = (
  sum: string | null,
  amountArray: (string | null)[] | undefined
) => {
  return (
    Number(sum) -
    (amountArray?.reduce((total, item) => total + Number(item), 0) ?? 0)
  );
};
export const rightAlignHeaderStyle: Partial<IDetailsColumnStyles> = {
  cellTitle: {
    justifyContent: 'flex-end',
  },
};
export const commonColumnProps: Partial<ColumnData> = {
  isResizable: true,
  isSorted: false,
  isPadded: false,
  isCollapsible: false,
  toggleVisibility: true,
  isVisible: true,
};
export const colHeaderLeftAlignStyle: Partial<IDetailsColumnStyles> = {
  cellTitle: {
    marginLeft: 0,
  },
};
export const centerAlignHeaderStyle: Partial<IDetailsColumnStyles> = {
  cellTitle: {
    justifyContent: 'center',
  },
};
export const commonColumnPropsConst: Partial<ColumnData> = {
  isResizable: true,
  isSorted: false,
  isSortedDescending: false,
  isCollapsible: true,
  toggleVisibility: true,
  isVisible: true,
};
export const commonDocumentColumnProps: Partial<ColumnData> = {
  isResizable: true,
  isSorted: false,
  isCollapsible: true,
  toggleVisibility: true,
  isVisible: true,
};
